module.exports = __webpack_public_path__ + "static/Hero-img-Mob-4366787465dc66e9d6e4dd82bef34013.jpg";